(function () {
  'use strict'

  var page = document.querySelector('[data-cart-page]')
  if (!page) return

  var sectionId = page.dataset.sectionId
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'
  var busy = false
  var labels = {
    update: page.dataset.errorUpdate,
    coupon: page.dataset.errorCoupon,
    postal: page.dataset.errorPostal,
    shipping: page.dataset.errorShipping,
    emptyShipping: page.dataset.emptyShipping,
    calculating: page.dataset.calculating
  }

  var limitConfig = null
  try {
    limitConfig = page.dataset.limitConfig ? JSON.parse(page.dataset.limitConfig) : null
  } catch (error) {
    limitConfig = null
  }
  var limitedProductIds = limitConfig && limitConfig.produtos
    ? limitConfig.produtos.map(function (gid) { return gid.replace(/\D/g, '') })
    : []

  // Espelha a checagem que a Function cart-validations-generate-run (sterilair-app,
  // extensions/limite-unidades) já faz no checkout — aqui é só UX: avisa mais cedo,
  // mas quem garante de verdade que ninguém passa do limite é a Function.
  // Só barra aumento. Se o carrinho já passou do limite — o lojista pode tê-lo
  // baixado depois —, reduzir precisa continuar valendo, senão o cliente fica
  // sem saída a não ser esvaziar o carrinho.
  function excedeLimite(lineChanged, novaQuantidade) {
    if (!limitConfig || !limitedProductIds.length) return false

    var alterada = document.querySelector('[data-cart-line][data-line="' + lineChanged + '"]')
    if (!alterada || limitedProductIds.indexOf(alterada.dataset.productId) === -1) return false
    var input = alterada.querySelector('[data-cart-quantity]')
    if (novaQuantidade <= Number(input.defaultValue)) return false

    var total = 0
    document.querySelectorAll('[data-cart-line]').forEach(function (lineItem) {
      if (limitedProductIds.indexOf(lineItem.dataset.productId) === -1) return
      var linha = Number(lineItem.dataset.line)
      total += linha === lineChanged ? novaQuantidade : Number(lineItem.querySelector('[data-cart-quantity]').defaultValue)
    })
    return total > limitConfig.limite
  }

  function setLoading(active) {
    busy = active
    var loader = document.querySelector('[data-cart-loading]')
    if (loader) {
      loader.hidden = !active
      loader.setAttribute('aria-hidden', String(!active))
    }
  }

  function setStatus(message) {
    var status = document.querySelector('[data-cart-status]')
    if (status) status.textContent = message || ''
  }

  function parseResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || labels.update)
      return data
    })
  }

  function replaceSection(data) {
    var html = data.sections && data.sections[sectionId]
    if (!html) {
      window.location.reload()
      return
    }

    var parsed = new DOMParser().parseFromString(html, 'text/html')
    var updated = parsed.querySelector('[data-cart-page]')
    var current = document.querySelector('[data-cart-page]')
    if (!updated || !current) {
      window.location.reload()
      return
    }

    current.replaceWith(updated)
    page = updated
    labels = {
      update: page.dataset.errorUpdate,
      coupon: page.dataset.errorCoupon,
      postal: page.dataset.errorPostal,
      shipping: page.dataset.errorShipping,
      emptyShipping: page.dataset.emptyShipping,
      calculating: page.dataset.calculating
    }

    var headerCount = document.getElementById('site-header-cart-count')
    if (headerCount && typeof data.item_count !== 'undefined') headerCount.textContent = data.item_count
  }

  function updateLine(line, quantity) {
    if (busy) return
    setStatus('')
    setLoading(true)

    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: Math.max(0, quantity),
        sections: [sectionId, 'minicart'],
        sections_url: window.location.pathname
      })
    })
      .then(parseResponse)
      .then(replaceSection)
      .catch(function (error) { setStatus(error.message) })
      .finally(function () { setLoading(false) })
  }

  function updateDiscount(code) {
    if (busy) return
    setStatus('')
    setLoading(true)

    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        discount: code,
        sections: [sectionId, 'minicart'],
        sections_url: window.location.pathname
      })
    })
      .then(parseResponse)
      .then(function (data) {
        // Em /cart/update.js cart_level_discount_applications vem aninhado
        // (discount_application.type), então a prova de que o cupom valeu é
        // discount_codes, que traz o código digitado e se ele se aplica.
        var codes = data.discount_codes || []
        var applied = codes.some(function (entry) {
          return entry.applicable && entry.code.toLowerCase() === code.toLowerCase()
        })
        if (code && !applied) {
          // Tira o código recusado da sessão para não ficar gravado sem aparecer.
          return fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          }).then(function () { throw new Error(labels.coupon) })
        }
        replaceSection(data)
      })
      .catch(function (error) { setStatus(error.message) })
      .finally(function () { setLoading(false) })
  }

  function formatPostalCode(value) {
    var digits = value.replace(/\D/g, '').slice(0, 8)
    return digits.length > 5 ? digits.slice(0, 5) + '-' + digits.slice(5) : digits
  }

  function formatMoney(amount) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(amount))
  }

  // Igual a assets/product-shipping-estimate.js: promoção de frete grátis chega
  // com price "0.00", e "R$ 0,00" não diz ao cliente que ele ganhou o frete.
  function formatShippingPrice(amount) {
    return Number(amount) === 0 ? '<span class="shipping-free">Grátis</span>' : formatMoney(amount)
  }

  function formatDeliveryDate(value) {
    var date = new Date(value)
    if (isNaN(date.getTime())) return ''
    return date.toLocaleDateString('pt-BR', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' })
  }

  function escapeHtml(value) {
    var node = document.createElement('div')
    node.textContent = value || ''
    return node.innerHTML
  }

  function brazilianProvince(postalCode) {
    var cep = Number(postalCode.replace(/\D/g, ''))
    var ranges = [
      [1000000, 19999999, 'SP'], [20000000, 28999999, 'RJ'], [29000000, 29999999, 'ES'],
      [30000000, 39999999, 'MG'], [40000000, 48999999, 'BA'], [49000000, 49999999, 'SE'],
      [50000000, 56999999, 'PE'], [57000000, 57999999, 'AL'], [58000000, 58999999, 'PB'],
      [59000000, 59999999, 'RN'], [60000000, 63999999, 'CE'], [64000000, 64999999, 'PI'],
      [65000000, 65999999, 'MA'], [66000000, 68899999, 'PA'], [68900000, 68999999, 'AP'],
      [69000000, 69299999, 'AM'], [69300000, 69399999, 'RR'], [69400000, 69899999, 'AM'],
      [69900000, 69999999, 'AC'], [70000000, 72799999, 'DF'], [72800000, 72999999, 'GO'],
      [73000000, 73699999, 'DF'], [73700000, 76799999, 'GO'], [76800000, 76999999, 'RO'],
      [77000000, 77999999, 'TO'], [78000000, 78899999, 'MT'], [79000000, 79999999, 'MS'],
      [80000000, 87999999, 'PR'], [88000000, 89999999, 'SC'], [90000000, 99999999, 'RS']
    ]
    var range = ranges.find(function (entry) { return cep >= entry[0] && cep <= entry[1] })
    return range ? range[2] : ''
  }

  function shippingAddressQuery(postalCode, province) {
    return '?shipping_address%5Bzip%5D=' + encodeURIComponent(postalCode) +
      '&shipping_address%5Bcountry%5D=Brazil' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(province)
  }

  function pollShippingRates(postalCode, province, attempt) {
    var target = document.querySelector('[data-shipping-results]')
    return fetch(root + 'cart/async_shipping_rates.json' + shippingAddressQuery(postalCode, province), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (response.status === 202 && attempt < 12) {
          return new Promise(function (resolve) {
            window.setTimeout(function () { resolve(pollShippingRates(postalCode, province, attempt + 1)) }, 650)
          })
        }
        return parseResponse(response)
      })
      .then(function (data) {
        if (!data || !data.shipping_rates || !target) return
        if (!data.shipping_rates.length) {
          target.innerHTML = '<p class="cart-page__shipping-error">' + labels.emptyShipping + '</p>'
          return
        }
        target.innerHTML = data.shipping_rates.map(function (rate) {
          var estimate = formatDeliveryDate(rate.delivery_date)
          return '<div class="cart-page__shipping-rate">' +
            '<div class="cart-page__shipping-rate-info"><strong>' + escapeHtml(rate.name) + '</strong>' +
            (estimate ? '<span>Estimado: ' + estimate + '</span>' : '') + '</div>' +
            '<div class="cart-page__shipping-rate-price">' + formatShippingPrice(rate.price) + '</div>' +
          '</div>'
        }).join('')
      })
  }

  function calculateShipping(postalCode) {
    var target = document.querySelector('[data-shipping-results]')
    var province = brazilianProvince(postalCode)
    if (postalCode.replace(/\D/g, '').length !== 8 || !province) {
      if (target) target.innerHTML = '<p class="cart-page__shipping-error">' + labels.postal + '</p>'
      return
    }

    if (target) target.textContent = labels.calculating
    fetch(root + 'cart/prepare_shipping_rates.json' + shippingAddressQuery(postalCode, province), {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok && response.status !== 202) return parseResponse(response)
        return pollShippingRates(postalCode, province, 0)
      })
      .catch(function () {
        if (target) target.innerHTML = '<p class="cart-page__shipping-error">' + labels.shipping + '</p>'
      })
  }

  document.addEventListener('input', function (event) {
    if (event.target.matches('[data-postal-code]')) event.target.value = formatPostalCode(event.target.value)
  })

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-quantity]')) return
    var lineItem = event.target.closest('[data-cart-line]')
    if (!lineItem) return
    var linha = Number(lineItem.dataset.line)
    var novaQuantidade = Number(event.target.value)
    if (excedeLimite(linha, novaQuantidade)) {
      if (typeof showToast === 'function') showToast(limitConfig.mensagem || labels.update, 'error')
      event.target.value = event.target.defaultValue
      return
    }
    updateLine(linha, novaQuantidade)
  })

  document.addEventListener('click', function (event) {
    var target = event.target.closest('button')
    if (!target || !target.closest('[data-cart-page]')) return

    var lineItem = target.closest('[data-cart-line]')
    var input = lineItem && lineItem.querySelector('[data-cart-quantity]')
    if (target.matches('[data-cart-increase]') && input && excedeLimite(Number(lineItem.dataset.line), Number(input.value) + 1)) {
      if (typeof showToast === 'function') showToast(limitConfig.mensagem || labels.update, 'error')
      return
    }
    if (target.matches('[data-cart-decrease]') && input) updateLine(Number(lineItem.dataset.line), Number(input.value) - 1)
    if (target.matches('[data-cart-increase]') && input) updateLine(Number(lineItem.dataset.line), Number(input.value) + 1)
    if (target.matches('[data-cart-remove]') && lineItem) updateLine(Number(lineItem.dataset.line), 0)
    if (target.matches('[data-discount-apply]')) {
      var discountInput = document.querySelector('[data-discount-input]')
      if (discountInput && discountInput.value.trim()) updateDiscount(discountInput.value.trim())
    }
    if (target.matches('[data-discount-remove]')) updateDiscount('')
    if (target.matches('[data-calculate-shipping]')) {
      var postalInput = document.querySelector('[data-postal-code]')
      if (postalInput) calculateShipping(postalInput.value)
    }
  })

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return
    if (event.target.matches('[data-discount-input]')) {
      event.preventDefault()
      updateDiscount(event.target.value.trim())
    }
    if (event.target.matches('[data-postal-code]')) {
      event.preventDefault()
      calculateShipping(event.target.value)
    }
  })
})()
